import { AdvertisingPartnerType, type ValueOf } from '$houdini';
import { writable } from 'svelte/store';

export interface PartnerBoxmapInfo {
	type: ValueOf<typeof AdvertisingPartnerType>;
	context: 'itinerary_search' | 'itinerary_result_layout' | 'map_result';
}

export function createPartnerBoxmapsStore(initialBoxmaps: PartnerBoxmapInfo[] = []) {
	const boxmapsForItineraryStore = writable<PartnerBoxmapInfo[]>(initialBoxmaps);

	return boxmapsForItineraryStore;
}

/**
 * Type guard: check if a value is a valid AdvertisingPartnerType value.
 */
export function isAdvertisingPartnerType(value: unknown): value is ValueOf<typeof AdvertisingPartnerType> {
	if (typeof value !== 'string') return false;
	for (const v of Object.values(AdvertisingPartnerType)) {
		if (v === value) return true;
	}
	return false;
}
